export function transformData<Type>(data: GenericObject | GenericObject[], map: GenericObject) {
	function isObjectOrArray(item: Object | Array<unknown> | null) {
		return typeof item === "object" && item !== null;
	}

	function transformEntity(entity: GenericObject): GenericObject {
		return Object.fromEntries(
			Object.entries(entity || {}).map(([key, value]) => {
				const mappedKey = map[key];

				if (mappedKey) {
					if (isObjectOrArray(value) && isObjectOrArray(mappedKey)) {
						const transformedObject = transformData(value, mappedKey);

						const objectKey = mappedKey.__key;
						return [objectKey || key, transformedObject];
					}

					return [mappedKey, value];
				} else {
					return [key, value];
				}
			})
		);
	}

	const transformed = Array.isArray(data) ? data.map(transformEntity) : transformEntity(data);

	return transformed as Type;
}
